import { createSignal, Show, type Component, type JSX } from 'solid-js';

export interface SettingsAccordionSectionProps {
  title: string;
  dataTestId: string;
  children: JSX.Element;
  defaultExpanded?: boolean;
  onExpand?(): void;
}

export const SettingsAccordionSection: Component<
  SettingsAccordionSectionProps
> = (props) => {
  const [isExpanded, setIsExpanded] = createSignal(
    props.defaultExpanded ?? false
  );

  const handleExpandedChange = (
    event: CustomEvent<{ expanded: boolean }>
  ): void => {
    const nextExpanded = event.detail.expanded;
    setIsExpanded(nextExpanded);
    if (nextExpanded) {
      props.onExpand?.();
    }
  };

  return (
    <modus-wc-accordion
      attr:data-testid={props.dataTestId}
      class="border-b border-trimble-gray-300"
    >
      <modus-wc-collapse
        bordered={false}
        expanded={isExpanded()}
        on:expandedChange={handleExpandedChange}
      >
        <h4
          slot="header"
          class="font-sans font-normal"
          textContent={props.title}
        />
        <div slot="content" class="p-[1rem]">
          <Show when={isExpanded()}>{props.children}</Show>
        </div>
      </modus-wc-collapse>
    </modus-wc-accordion>
  );
};
